export const colorsBackground = [
  '#B58F08',
  '#BD160B',
  '#999999',
  '#2F402F',
  '#53638A',
  '#5E169E',
]

export const colorsFonts = [
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
]
